module.exports = __webpack_public_path__ + "./img/404_cloud.png";